import {Component, Input} from '@angular/core';
import {ProfileType} from '../../model/profile-type.model';
import {ConfigService} from '../../service/config.service';

@Component({
    selector: 'app-campaign-enquire-footer',
    templateUrl: './campaign-enquire-footer.component.html',
    styleUrls: ['./campaign-enquire-footer.component.css']
})
export class CampaignEnquireFooterComponent {
    @Input()
    profileType: ProfileType;
    ProfileType = ProfileType;
    private configService: ConfigService;
 
    constructor(configService: ConfigService){
        this.configService = configService;
        }

        public downloadLSP(){
            const finzyPartenrsLSP = this.configService.getDownloadLSP();
            window.open(finzyPartenrsLSP, '_blank');
        }
    
        public downloadLOC(){
            const finzyPartenrsLOC = this.configService.getDownloadLOC();
            window.open(finzyPartenrsLOC, '_blank');
            }
}
